(function () {
    'use strict';
    var controllerId = 'invioInvito';
    angular.module('app').controller(controllerId, ['$scope', '$uibModalInstance', 'datacontext', 'societa', invioInvitoFn]);

    function invioInvitoFn($scope, $uibModalInstance, datacontext, societa) {
        var extSocieta = [];        
        societa.forEach(function (s) {            
            var u = {};
            angular.copy(s, u);
            u.Selected = false;
            u.Sent = false;
            u.Esito = '';
            extSocieta.push(u);
        });

        $scope.societa = extSocieta;
        $scope.selezionati = 0;
        $scope.exit = false;

        $scope.ok = function () {            
            var i = 0;            
            setInterval(function () {
                if($scope.exit == true)
                    return;
                $scope.loading = true;
                if (i < $scope.societa.length) {
                    if ($scope.societa[i].Selected == true) {
                        if ($scope.societa[i].Sent != true) {
                            $scope.societa[i].Sent = true;
                            datacontext.societa_inviaInvito($scope.societa[i].Id).then(function (data) {                                
                                if (data.status != "200") {
                                    $scope.societa[i].Esito = data.data;
                                }
                                else {
                                    $scope.societa[i].Esito = 'OK';
                                    $scope.societa[i].DataInvito = data.data;
                                }
                                i++;
                            });
                        }
                    }
                    else i++;
                }
                $scope.loading = false;
            }, 1000);            
        };

        $scope.cancel = function () {
            $scope.exit = true;
            $uibModalInstance.dismiss('cancel');
        };

        $scope.selezionaTutti = function () {
            $scope.selezionati = 0;
            $scope.societa.forEach(function (user) {                
                user.Selected = true;
                $scope.selezionati++;
            });
        }

        $scope.societa_Seleziona = function (selezionato) {
            if (selezionato == true)
                $scope.selezionati++;
            else
                $scope.selezionati--;
        };

        $scope.export = function() {
            var ua = window.navigator.userAgent;
            var trident = ua.indexOf("Trident");
            var msie = ua.indexOf("MSIE ");

            if (msie > 0 || trident > 0) {
                var table = $('#exportSocieta');
                var strCopy = $('<div></div>').html(table.clone()).html(); window.clipboardData.setData("Text", strCopy);

                var objExcel = new ActiveXObject("Excel.Application");
                objExcel.visible = false;
                var objWorkbook = objExcel.Workbooks.Add;
                var objWorksheet = objWorkbook.Worksheets(1);
                objWorksheet.Paste;
                objExcel.visible = true;
            }
            else {
                $('#exportSocieta').tableExport({ type: 'excel', escape: false });
            }
        }
    }
})();